// WebInfoContext.jsx
import React, {createContext, useState, useEffect} from "react";
import axios from "axios";
import {useTranslation} from "react-i18next";

export const ContactInfoContext = createContext();

// eslint-disable-next-line react/prop-types
export const ContactInfoProvider = ({children}) => {
    const {i18n} = useTranslation();
    const [contactInfo, setContactInfo] = useState({
        "logoImages": "",
        "aboutUsImages": "",
        "processingImages": "",
        "tintedImages": "",
        "tintedHeaderImages": "",
        "coveringImages": "",
        "ourGalleryImages": "",
        "partnersImages": "",

        "addressEn": "",
        "addressFr": "",
        "email": "",
        "telPhone": "",
        "wpPhone": "",
        "viberPhone": "",
        "tgUsername": "",
        "messenger": "",
        "instagramUrl": "",
        "facebookUrl": "",
        "googleMapsUrl": "",
    });
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const source = axios.CancelToken.source();
        const fetchContactInfo = async () => {
            try {
                setIsLoading(true);
                const res = await
                    axios.get(`${process.env.REACT_APP_API_KEY}/arscustom/public/web/contact-information`);

                setContactInfo(res.data);
                setError(null);
            } catch (err) {
                if (!axios.isCancel(err)) {
                    console.error("Error fetching contact information:", err);
                    setError(err.message);
                }
            } finally {
                setIsLoading(false);
            }
        };

        fetchContactInfo();

        return () => {
            source.cancel("Request cancelled due to language change or unmount");
        };
    }, [i18n.language]);

    return (
        <ContactInfoContext.Provider value={{contactInfo, isLoading, error}}>
            {children}
        </ContactInfoContext.Provider>
    );
};
